import { render, staticRenderFns } from "./FormGestionPqr.vue?vue&type=template&id=aff9abb4&scoped=true"
import script from "./FormGestionPqr.vue?vue&type=script&lang=js"
export * from "./FormGestionPqr.vue?vue&type=script&lang=js"
import style0 from "./FormGestionPqr.vue?vue&type=style&index=0&id=aff9abb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9abb4",
  null
  
)

export default component.exports